import { forwardRef } from 'preact/compat'
import { globalState, localeSearchUrl } from '@/components/helpers/utils'

export const SearchInput = forwardRef(({ onInput, redirect }, ref) => {
  return (
    <input
      ref={ref}
      onInput={onInput}
      className="field-input h5 shrink-0 grow border-0 p-0 lg:h4 focus:border-0"
      type="text"
      name="query"
      placeholder={globalState.search.searchDropdownPlaceholder || 'Search our range by colour, style, material...'}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (redirect) {
            window.location.href = redirect
          } else {
            window.location.href = localeSearchUrl(e.target.value)
          }
        }
      }}
    />
  )
})
